import { validateDate } from './dateUtils'

export const validateCurriculumForm = (values) => {
  const errors = {}
  
  // Validate college name if higher education is selected
  if (['college', 'graduate'].includes(values.educationLevel)) {
    if (!values.collegeName?.trim()) {
      errors.collegeName = 'Nome da instituição é obrigatório para ensino superior'
    }
    
    if (!values.studyStatus) {
      errors.studyStatus = 'Status dos estudos é obrigatório'
    }
    
    if (!values.studyStartDate?.trim()) {
      errors.studyStartDate = 'Data de início é obrigatória'
    } else if (!validateDate(values.studyStartDate)) {
      errors.studyStartDate = 'Data de início inválida'
    }
    
    // Validate end date if status is finished
    if (values.studyStatus === 'finished') {
      if (!values.studyEndDate?.trim()) {
        errors.studyEndDate = 'Data de conclusão é obrigatória quando concluído'
      } else if (!validateDate(values.studyEndDate)) {
        errors.studyEndDate = 'Data de conclusão inválida'
      }
    }
    
    // Validate study period if status is studying
    if (values.studyStatus === 'studying' && !values.studyPeriod) {
      errors.studyPeriod = 'Período de estudo é obrigatório quando estudando'
    }
    
    // Validate date logic
    if (values.studyStartDate && values.studyEndDate && 
        validateDate(values.studyStartDate) && validateDate(values.studyEndDate)) {
      const startDate = new Date(values.studyStartDate.split('/').reverse().join('-'))
      const endDate = new Date(values.studyEndDate.split('/').reverse().join('-'))
      
      if (startDate >= endDate) {
        errors.studyEndDate = 'Data de conclusão deve ser posterior à data de início'
      }
    }
  }
  
  return errors
}

export const getValidationErrorMessages = () => ({
  'Nome da instituição é obrigatório para ensino superior': 'Nome da instituição é obrigatório para ensino superior',
  'Status dos estudos é obrigatório': 'Status dos estudos é obrigatório',
  'Data de início é obrigatória': 'Data de início é obrigatória',
  'Data de início inválida': 'Data de início inválida',
  'Data de conclusão é obrigatória quando concluído': 'Data de conclusão é obrigatória quando concluído',
  'Data de conclusão inválida': 'Data de conclusão inválida',
  'Período de estudo é obrigatório quando estudando': 'Período de estudo é obrigatório quando estudando',
  'Data de conclusão deve ser posterior à data de início': 'Data de conclusão deve ser posterior à data de início'
})